/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Outline_Size_LabelInputs */

const en_video_export_outline_size_label = /** @type {(inputs: Video_Export_Outline_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outline Size`)
};

const fr_video_export_outline_size_label = /** @type {(inputs: Video_Export_Outline_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille du contour`)
};

const de_video_export_outline_size_label = /** @type {(inputs: Video_Export_Outline_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umrissgröße`)
};

const it_video_export_outline_size_label = /** @type {(inputs: Video_Export_Outline_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensioni del contorno`)
};

const ru_video_export_outline_size_label = /** @type {(inputs: Video_Export_Outline_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер контура`)
};

const es_video_export_outline_size_label = /** @type {(inputs: Video_Export_Outline_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño del contorno`)
};

const zh_cn2_video_export_outline_size_label = /** @type {(inputs: Video_Export_Outline_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轮廓尺寸`)
};

const ja_video_export_outline_size_label = /** @type {(inputs: Video_Export_Outline_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アウトラインサイズ`)
};

const hi_video_export_outline_size_label = /** @type {(inputs: Video_Export_Outline_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रूपरेखा का आकार`)
};

const pt_pt2_video_export_outline_size_label = /** @type {(inputs: Video_Export_Outline_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho do contorno`)
};

/**
* | output |
* | --- |
* | "Outline Size" |
*
* @param {Video_Export_Outline_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_outline_size_label = /** @type {((inputs?: Video_Export_Outline_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Outline_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_outline_size_label(inputs)
	if (locale === "de") return de_video_export_outline_size_label(inputs)
	if (locale === "it") return it_video_export_outline_size_label(inputs)
	if (locale === "ru") return ru_video_export_outline_size_label(inputs)
	if (locale === "es") return es_video_export_outline_size_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_outline_size_label(inputs)
	if (locale === "ja") return ja_video_export_outline_size_label(inputs)
	if (locale === "hi") return hi_video_export_outline_size_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_outline_size_label(inputs)
	return en_video_export_outline_size_label(inputs)
});